export enum ENotificationType {
  INFO = 'INFO',
  ERROR = 'ERROR',
}
